<template>
  <div>
    <div class="WisdomSiteContainer">
      <Row justify="center" type="flex">
        <Col span="24">
          <img
            style="width: 100%; height: 400px"
            src="../../static/img/WisdomSite/背景1.png"
            alt="#"
          />
        </Col>
        <Col :xs="25" :sm="25" :md="15" :lg="15" :xl="15">
          <div style="margin-left: 10px">
            <router-view></router-view>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuTheme: "light",
      CompanyProfile: [
        {
          url: "../../static/img/photo-da/photo_huitan.jpg",
          intro: "无线蓝牙回弹仪",
          path: "Resiliometer",
        },
        {
          url: "../../static/img/photo/photo_anquan.png",
          intro: "安全隐患排查系统",
          path: "HiddenDanger",
        },
      ],
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    goBackBuy(path) {
      this.$router.push({
        name: path,
      });
    },
  },
};
</script>

<style scoped>
.WisdomSiteContainer {
  background: #f8f8f8;
}

.WisdomSiteContainer_title {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  font-family: 微软雅黑, serif;
  line-height: 100px;
  color: #000;
}

.WisdomSiteContainer_img {
  text-align: center;
  margin: 14px 0;
}

.WisdomSiteContainer_img img {
  width: 98%;
  border-radius: 5px;
}

.Industrystatusquo_img {
  text-align: center;
  margin: 14px 0;
}

.Industrystatusquo_img img {
  width: 49%;
  border-radius: 5px;
  margin-top: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue